const config = () => {
    return {
        ipServer: "https://api.solmsn.com",
    };
};

export { config };
